import { render } from "./SpeakerFade.vue?vue&type=template&id=55740d40&ts=true&lang=pug"
import script from "./SpeakerFade.vue?vue&type=script&setup=true&lang=ts"
export * from "./SpeakerFade.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__